// document.addEventListener("DOMContentLoaded", () => {
//   const accordionHeaders = document.querySelectorAll(".collection-grid-wrapper:not(.hidden) .collection-filters .accordion-header");

//   accordionHeaders.forEach(header => {
//     const accordionItem = header.closest(".accordion-item");
//     const content = accordionItem.querySelector(".accordion-content");
    
//     if (content) {
//       header.addEventListener("click", (e) => {
//         e.preventDefault();
        
//         const isOpen = accordionItem.classList.contains("active");

//         document.querySelectorAll(".collection-grid-wrapper:not(.hidden) .collection-filters .accordion-item").forEach(item => {
//           item.classList.remove("active");
//         });
//         document.querySelectorAll(".collection-grid-wrapper:not(.hidden) .collection-filters .accordion-content").forEach(c => {
//           c.style.maxHeight = null;
//         });
//         if (!isOpen) {
//           content.style.maxHeight = content.scrollHeight + "px";
//           accordionItem.classList.add("active");
//         }
//       });
//     }
//   });

//   const activeLink = document.querySelector(".collection-grid-wrapper:not(.hidden) .collection-filters .accordion-content a.active");
//   if (activeLink) {
//     const parentAccordion = activeLink.closest(".accordion-item");
//     const parentContent = parentAccordion.querySelector(".accordion-content");
    
//     if (parentContent) {
//       parentAccordion.classList.add("active");
//       parentContent.style.maxHeight = parentContent.scrollHeight + "px";
//     }
//   }

//   const toggleBtn = document.querySelector(".collection-grid-wrapper:not(.hidden) .collection-filters .filters-toggle");
//   const accordionMenu = document.querySelector(".collection-grid-wrapper:not(.hidden) .collection-filters .filters-accordion");

//   toggleBtn?.addEventListener("click", () => {
//     accordionMenu.classList.toggle("active");
//   });
// });

document.addEventListener("DOMContentLoaded", () => {
  initAccordion();
  initMobileToggle();
});

window.addEventListener("load", () => {
  openActiveAccordion();
});

// ─── Accordion open/close ───────────────────────────────────────────────────
function initAccordion() {
  const selector = ".collection-grid-wrapper:not(.hidden) .collection-filters";

  document.querySelectorAll(`${selector} .accordion-header`).forEach(header => {
    const accordionItem = header.closest(".accordion-item");
    const content = accordionItem.querySelector(":scope > .accordion-content");
    if (!content) return;

    header.addEventListener("click", (e) => {
      e.preventDefault();
      const isOpen = accordionItem.classList.contains("active");

      const siblings = accordionItem.parentElement.querySelectorAll(":scope > .accordion-item");
      siblings.forEach(sibling => {
        if (sibling === accordionItem) return;
        const sibContent = sibling.querySelector(":scope > .accordion-content");
        if (sibContent) closeAccordion(sibling, sibContent);
      });

      if (!isOpen) {
        openAccordion(accordionItem, content);
        updateAncestorHeights(accordionItem);
      } else {
        closeAccordion(accordionItem, content);
      }
    });
  });
}

// ─── Measure true height and animate open ───────────────────────────────────
function openAccordion(item, content) {
  item.classList.add("active");
  content.style.transition = "none";
  content.style.maxHeight = "none";
  const targetHeight = content.scrollHeight;
  content.style.maxHeight = "0px";
  content.offsetHeight;
  content.style.transition = "";
  content.style.maxHeight = targetHeight + "px";
}

// ─── Snapshot rendered height and animate closed ─────────────────────────────
function closeAccordion(item, content) {
  const currentHeight = content.getBoundingClientRect().height;
  content.style.maxHeight = currentHeight + "px";
  item.classList.remove("active");
  requestAnimationFrame(() => {
    content.style.maxHeight = "0px";
  });
}

// ─── Recalculate maxHeight on all currently active items in a container ──────
function recalculateActiveAccordions(container) {
  if (!container) return;

  // reverse() = innermost first → parent scrollHeight includes correct child heights
  const activeItems = Array.from(
    container.querySelectorAll(".accordion-item.active")
  ).reverse();

  activeItems.forEach(item => {
    const content = item.querySelector(":scope > .accordion-content");
    if (!content) return;
    content.style.transition = "none";
    content.style.maxHeight = "none";
    const h = content.scrollHeight;
    content.style.maxHeight = h + "px";
    content.offsetHeight;
    content.style.transition = "";
  });
}

// ─── Walk up DOM and refresh maxHeight on every open ancestor ───────────────
function updateAncestorHeights(startItem) {
  setTimeout(() => {
    let parent = startItem.parentElement?.closest(".accordion-item");
    while (parent) {
      if (parent.classList.contains("active")) {
        const parentContent = parent.querySelector(":scope > .accordion-content");
        if (parentContent) {
          parentContent.style.transition = "none";
          parentContent.style.maxHeight = "none";
          const h = parentContent.scrollHeight;
          parentContent.style.maxHeight = h + "px";
          parentContent.offsetHeight;
          parentContent.style.transition = "";
        }
      }
      parent = parent.parentElement?.closest(".accordion-item");
    }
  }, 310);
}

// ─── Auto-open accordion containing the active link ─────────────────────────
function openActiveAccordion() {
  const selector = ".collection-grid-wrapper:not(.hidden) .collection-filters";
  const activeLink = document.querySelector(`${selector} .accordion-content a.active`);
  if (!activeLink) return;

  const itemsToOpen = [];
  let item = activeLink.closest(".accordion-item");
  while (item) {
    itemsToOpen.push(item);
    item = item.parentElement?.closest(".accordion-item");
  }

  itemsToOpen.forEach(accordionItem => {
    const content = accordionItem.querySelector(":scope > .accordion-content");
    if (!content) return;
    accordionItem.classList.add("active");
    content.style.transition = "none";
    content.style.maxHeight = "none";
    const h = content.scrollHeight;
    content.style.maxHeight = h > 0 ? h + "px" : "0px";
  });

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      itemsToOpen.forEach(accordionItem => {
        const content = accordionItem.querySelector(":scope > .accordion-content");
        if (content) content.style.transition = "";
      });
    });
  });
}

// ─── Mobile categories toggle ────────────────────────────────────────────────
function initMobileToggle() {
  const selector = ".collection-grid-wrapper:not(.hidden) .collection-filters";
  const toggleBtn = document.querySelector(`${selector} .filters-toggle`);
  const accordionMenu = document.querySelector(`${selector} .filters-accordion`);

  if (!toggleBtn || !accordionMenu) return;

  toggleBtn.addEventListener("click", () => {
    const isOpening = !accordionMenu.classList.contains("active");
    accordionMenu.classList.toggle("active");

    if (isOpening) {
      requestAnimationFrame(() => {
        recalculateActiveAccordions(accordionMenu);
      });
    }
  });
}